import { Box, CircularProgress } from '@mui/material';

const LoadingLayout: React.FC = () => (
  <Box
    sx={{
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CircularProgress />
  </Box>
);

export default LoadingLayout;
